import { render, staticRenderFns } from "./chooseOrderCarton.vue?vue&type=template&id=6033815a&scoped=true&"
import script from "./chooseOrderCarton.vue?vue&type=script&lang=js&"
export * from "./chooseOrderCarton.vue?vue&type=script&lang=js&"
import style0 from "./chooseOrderCarton.vue?vue&type=style&index=0&id=6033815a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6033815a",
  null
  
)

export default component.exports